import { render, staticRenderFns } from "./CustomerChart.vue?vue&type=template&id=28f93b20&"
import script from "./CustomerChart.vue?vue&type=script&lang=js&"
export * from "./CustomerChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f93b20')) {
      api.createRecord('28f93b20', component.options)
    } else {
      api.reload('28f93b20', component.options)
    }
    module.hot.accept("./CustomerChart.vue?vue&type=template&id=28f93b20&", function () {
      api.rerender('28f93b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/partials/CustomerChart.vue"
export default component.exports